import api from './axios';

export const resumo = (dias = 30) => api.get('/estatisticas/resumo', { params: { dias } });
